import { useTranslations } from "next-intl";
import { Vhr } from "domain/User/Common/utils/dashboard-api";
import { ComponentFrame } from "@carfax/web-ui/components/ComponentFrame";
import { useRoutes } from "domain/Routing/hooks/useRoutes";

import React from "react";
import { styles } from "./ReportSection.style";
import ReportCard from "./ReportCard";
import { NoReportsBackground } from "@carfax/web-ui/components/NoReportsBackground";
import { SkeletonReportCard } from "@carfax/web-ui/components/ReportCard";
import { linkUtil } from "utils/i18n/link-util";

interface IProps {
  reports: Vhr[];
  isLoading?: boolean;
}

const ReportSection: React.FC<IProps> = ({ reports, isLoading = false }) => {
  const tDashboard = useTranslations("page-account-dashboard");
  const tReports = useTranslations("page-account-reports");
  const routes = useRoutes();

  const linkToReports = linkUtil.i18nLink(routes.accountReports);
  const reportButtonText = tDashboard("reportSection.viewReportButton");
  const sectionTitle = tDashboard("reportSection.headline");
  const reportsAvailable = reports?.length > 0;

  return (
    <div className={styles.sectionWrapper()} id="reports" data-testid="dashboard-report-section">
      <ComponentFrame
        title={sectionTitle}
        buttonText={reportButtonText}
        linkTo={reportsAvailable && linkToReports}
        testId="show-all-reports-button"
      >
        {isLoading ? (
          <div className={styles.childLimiter()}>
            {Array.from({ length: 2 }, (_, index) => (
              <SkeletonReportCard key={`skeleton-${index}`} displayShortCard />
            ))}
          </div>
        ) : reportsAvailable ? (
          <div className={styles.childLimiter()}>
            {reports.slice(0, 3).map((report) => (
              <ReportCard key={report.uuid} {...report} />
            ))}
          </div>
        ) : (
          <NoReportsBackground
            title={tReports("sectionReports.noReportsTitle")}
            description={tReports("sectionReports.noReportsDescription")}
            noBorder
          />
        )}
      </ComponentFrame>
    </div>
  );
};

export default ReportSection;
